﻿global.moment = moment;
global.$ = $;
import * as daterangepicker from 'Vendors/daterangepicker/daterangepicker';
global.daterangepicker = daterangepicker;

import('Vendors/jquery.outerHTML');

/**
* @version: 3.0.5
* @author: Dan Grossman http://www.dangrossman.info/
* @copyright: Copyright (c) 2012-2019 Dan Grossman. All rights reserved.
* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
* @website: http://www.daterangepicker.com/
*/
// Following the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Make globaly available as well
        define(['moment', 'jquery'], function (root, moment, jquery) {
            if (!jquery.fn) jquery.fn = {}; // webpack server rendering
            if (typeof moment !== 'function' && moment.default) moment = moment.default
            return factory(root, moment, jquery);
        });
    } else if (typeof module === 'object' && module.exports) {
        // Node / Browserify
        //isomorphic issue
        var jQuery = (typeof window != 'undefined') ? window.jQuery : undefined;
        if (!jQuery) {
            jQuery = require('jquery');
            if (!jQuery.fn) jQuery.fn = {};
        }
        var moment = (typeof window != 'undefined' && typeof window.moment != 'undefined') ? window.moment : require('moment');
        module.exports = factory(root, moment, jQuery);
    } else {
        // Browser globals
        root.daterangepicker = factory(root, root.moment, root.$);
    }
}(global, function (root, moment, $) {

    //var DateRangePicker = root.daterangepicker;

    function useModalDropDown() {
        //var bp_Width = $(window).width();
        var bp_Width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
        return bp_Width < 768;
    }

    function extend(base, sub, methods) {
        sub.prototype = Object.create(base.prototype);
        sub.prototype.constructor = sub;
        sub.base = base.prototype;

        // Copy the methods passed in to the prototype
        for (var name in methods) {
            sub.prototype[name] = methods[name];
        }
        // so we can define the constructor inline
        return sub;
    }

    var DateRangePicker = function (element, options, cb) {
        //console.log('>>> before DateRangePicker.base.constructor');
        // inherit from base constructor
        // Call the parent's constructor without hard coding the parent
        DateRangePicker.base.constructor.call(this, element, options, cb);
        //console.log('>>> after DateRangePicker.base.constructor');


        /*
        this.initStartDate = moment().startOf('day');
        //this.initEndDate = moment().endOf('day');
        
        if (typeof options.initStartDate === 'string')
            this.initStartDate = moment(options.initStartDate, this.locale.format);

        //if (typeof options.initEndDate === 'string')
        //    this.initEndDate = moment(options.initEndDate, this.locale.format);

        if (typeof options.initStartDate === 'object')
            this.initStartDate = moment(options.initStartDate);

        //if (typeof options.initEndDate === 'object')
        //    this.initEndDate = moment(options.initEndDate);
        */

        this.initDate = null; // moment().startOf('day');
        if (typeof options.initDate === 'string')
            this.initDate = moment(options.initDate, this.locale.format);
        if (typeof options.initDate === 'object')
            this.initDate = moment(options.initDate);

        if (typeof options.showNavigation === 'undefined') {
            this.showNavigation = true;
        } else {
            this.showNavigation = options.showNavigation;
        }

        if (typeof options.showMonthNavigation === 'undefined') {
            this.showMonthNavigation = true;
        } else {
            this.showMonthNavigation = options.showMonthNavigation;
        }

        if (typeof options.inline === 'undefined') {
            this.inline = false;
        } else {
            this.inline = options.inline;
        }


        if (typeof options.renderDateAttributes === 'function') {
            this.renderDateAttributes = options.renderDateAttributes;
        }
        if (typeof options.renderDateValue === 'function') {
            this.renderDateValue = options.renderDateValue;
        }
        this.updateElement();

        if (this.inline && this.alwaysShowCalendars) {
            this.show();
        }
        
    }

    extend(root.daterangepicker, DateRangePicker, {
        test_extra_method: function () {
            console.log('test_extra_method');
            return "Ok";
        }
    });


    //selectedDate

    /*
    DateRangePicker.prototype.constructor_original = DateRangePicker.prototype.constructor;
    DateRangePicker.prototype.constructor = function(element, options, cb) {
        if (typeof options.renderDateValue === 'function') {
            this.renderDateValue = options.renderDateValue;
        }
        this.updateElement();
    };
    */

    DateRangePicker.prototype.renderDateValue = function(date, classes, calendarIndex) { 
        //console.log('prototype.renderDateValue', date);
        //debugger;
        return date.date(); 
    };
    DateRangePicker.prototype.renderDateAttributes = function(date, classes, calendarIndex) { 
        //console.log('prototype.renderAttributes', date);
        //debugger;
        return ''; 
    };

    DateRangePicker.prototype.is_showNavigation = function() { 
        let show_navigation = true;
        // if (typeof this.element.data().showNavigation === 'boolean') {
        //     show_navigation = this.element.data().showNavigation;
        // }
        // if (typeof this.element.data().showNavigation === 'function') {
        //     show_navigation = this.element.data().showNavigation();
        // }
        if (typeof this.showNavigation === 'boolean') {
            show_navigation = this.showNavigation;
        }
        if (typeof this.showNavigation === 'function') {
            show_navigation = this.showNavigation();
        }
        return show_navigation;
    };

    DateRangePicker.prototype.is_showMonthNavigation = function() { 
        let show_month_navigation = true;
        // if (typeof this.element.data().showMonthNavigation === 'boolean') {
        //     show_month_navigation = this.element.data().showMonthNavigation;
        // }
        // if (typeof this.element.data().showMonthNavigation === 'function') {
        //     show_month_navigation = this.element.data().showMonthNavigation();
        // }
        if (typeof this.showMonthNavigation === 'boolean') {
            show_month_navigation = this.showMonthNavigation;
        }
        if (typeof this.showMonthNavigation === 'function') {
            show_month_navigation = this.showMonthNavigation();
        }
        return show_month_navigation;
    };

    DateRangePicker.prototype.initExtend = function () {
        this.numberOfMonths = this.singleDatePicker ? 1 : 2;
        this.calendarList = [];

        if (typeof this.element.data().numberOfMonths === 'number')
            this.numberOfMonths = this.element.data().numberOfMonths;

        if (typeof this.element.data().numberOfMonths === 'function')
            this.numberOfMonths = this.element.data().numberOfMonths();

        if (typeof this.element.data().hideOtherMonthDays === 'boolean')
            this.hideOtherMonthDays = this.element.data().hideOtherMonthDays;

        this.initCalendarList();
    };

    DateRangePicker.prototype.useCalendarList = function () {
        if (!this.numberOfMonths) this.initExtend();
        // 2022-04-22 disable original impl.
        if (this.inline) return true;
        return this.numberOfMonths > 1;
    };

    DateRangePicker.prototype.dateContainedInCalendarList = function (date) {
        for (var i = 0; i < this.numberOfMonths; i++) {
            if (this.calendarList[i].month) {
                if (this.calendarList[i].month.format('YYYY-MM') == date.format('YYYY-MM')) {
                    return true;
                }
            }
        }
        return false;
    };

    DateRangePicker.prototype.updateEventListeners = function () {
        //
        // event listeners
        //
        this.container.find('.drp-calendar').off('.daterangepicker');
        this.container.find('.ranges').off('.daterangepicker');
        this.container.find('.drp-buttons').off('.daterangepicker');

        //$(document).on('click.daterangepicker', '.drp-calendar .prev', $.proxy(this.clickPrev, this))
        //    .on('click.daterangepicker', '.drp-calendar .next', $.proxy(this.clickNext, this))
        //    .on('mousedown.daterangepicker', '.drp-calendar td.available', $.proxy(this.clickDate, this))
        //    .on('mouseenter.daterangepicker', '.drp-calendar td.available', $.proxy(this.hoverDate, this))
        //    .on('change.daterangepicker', '.drp-calendar select.yearselect', $.proxy(this.monthOrYearChanged, this))
        //    .on('change.daterangepicker', '.drp-calendar select.monthselect', $.proxy(this.monthOrYearChanged, this))
        //    .on('change.daterangepicker', '.drp-calendar select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this));

        //$(document).on('click.daterangepicker', '.ranges li', $.proxy(this.clickRange, this));

        //$(document).on('click.daterangepicker', '.drp-buttons button.applyBtn', $.proxy(this.clickApply, this))
        //    .on('click.daterangepicker', '.drp-buttons button.cancelBtn', $.proxy(this.clickCancel, this));

        this.container.find('.drp-calendar')
            .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
            .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
            .on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
            .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
            .on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this))
            .on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this))
            .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this));

        this.container.find('.ranges')
            .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this));

        this.container.find('.drp-buttons')
            .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
            .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this));

        var _this = this;
        var resizer = function () {
            if (_this.isShowing) {
                _this.hide();
                _this.show();
            }
        };

        if (window.addEventListener) {
            window.addEventListener('resize', resizer);
        } else if (window.attachEvent) {
            window.attachEvent('onresize', resizer);
        }
    };

    DateRangePicker.prototype.updateTemplate = function () {
        // old version of clean up
        //this.container.find('.drp-calendar:not(.left)').remove();
        ///this.container.find('.drp-calendar').removeClass('left');
        //var calendarElement = this.container.find('.drp-calendar');
        // - - - - - -
        // new version of clean up
        var $calendars = this.container.find('.drp-calendar');
        if ($calendars.length > 1) {
            $calendars.slice(1).remove();
        }
        $calendars.removeClass('left');
        var calendarElement = this.container.find('.drp-calendar');
        // - - - - - -
        
        var calendarListHtml = '';
        for (var i = 0; i < this.numberOfMonths; i++) {
            let calendarElementClone = calendarElement.clone().attr("data-calendar-index", i);
            if (!this.singleDatePicker || this.numberOfMonths > 1) {
                if (i == 0) {
                    calendarElementClone.addClass('left');
                }
                if (i == this.numberOfMonths - 1) {
                    calendarElementClone.addClass('right');
                }
            }
            calendarListHtml += calendarElementClone.outerHTML();
        }
        calendarElement.replaceWith(calendarListHtml);
        this.updateEventListeners();
    };

    DateRangePicker.prototype.initCalendarList = function () {
        var old_numberOfMonths = this.numberOfMonths;
        if (this.calendarList) {
            if (typeof this.element.data().numberOfMonths === 'function')
                this.numberOfMonths = this.element.data().numberOfMonths();
            if (this.calendarList.length == this.numberOfMonths && old_numberOfMonths == this.numberOfMonths) return;
        }
        this.updateTemplate();
        this.calendarList = [];
        for (var i = 0; i < this.numberOfMonths; i++) {
            this.calendarList[i] = {};
        }
    };

    DateRangePicker.prototype.useInitDate = function () {
        return this.initDate && this.initDate.isValid();
    };

    DateRangePicker.prototype.getInitDate = function () {
        if (this.useInitDate()) {
            return this.initDate;
        } else {
            return this.startDate.clone();
        }
    };

    DateRangePicker.prototype.setInitDate = function (initDate) {
        if (typeof initDate === 'string')
            this.initDate = moment(initDate, this.locale.format);

        if (typeof initDate === 'object')
            this.initDate = moment(initDate);

        /*
        if (this.startDate.isValid()) {
            this.container.find('.drp-selected-startDate .text').html(this.startDate.format(this.locale.format));
            this.container.find('.drp-selected-endDate .text').html(AppData.Translations["calendar_arrival_date"]);
            this.container.find('.drp-selected-startDate .caption').removeClass("d-none");
            this.container.find('.drp-selected-endDate .caption').addClass("d-none");
        } else {
            this.container.find('.drp-selected-startDate .text').html(AppData.Translations["calendar_departure_date"]);
            this.container.find('.drp-selected-endDate .text').html(AppData.Translations["calendar_arrival_date"]);
            this.container.find('.drp-selected-startDate .caption').addClass("d-none");
            this.container.find('.drp-selected-endDate .caption').addClass("d-none");
        }
        if (!this.timePicker)
            this.startDate = this.startDate.startOf('day');

        if (this.timePicker && this.timePickerIncrement)
            this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

        if (this.minDate && this.startDate.isBefore(this.minDate)) {
            this.startDate = this.minDate.clone();
            if (this.timePicker && this.timePickerIncrement)
                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        }

        if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
            this.startDate = this.maxDate.clone();
            if (this.timePicker && this.timePickerIncrement)
                this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        }
        */

        if (!this.isShowing)
            this.updateElement();

        this.updateMonthsInView();

    };

    DateRangePicker.prototype.setMinDate = function (minDate) {
        if (typeof minDate === 'string')
            this.minDate = moment(minDate, this.locale.format);

        if (typeof minDate === 'object')
            this.minDate = moment(minDate);

        if (!this.isShowing)
            this.updateElement();

        this.updateMonthsInView();

    };
    DateRangePicker.prototype.setMaxDate = function (maxDate) {
        if (typeof maxDate === 'string')
            this.maxDate = moment(maxDate, this.locale.format);

        if (typeof maxDate === 'object')
            this.maxDate = moment(maxDate);

        if (!this.isShowing)
            this.updateElement();

        this.updateMonthsInView();

    };


    DateRangePicker.prototype.setStartDate_original = DateRangePicker.prototype.setStartDate;
    DateRangePicker.prototype.setStartDate = function (startDate) {
        if (typeof startDate === 'string')
            this.startDate = moment(startDate, this.locale.format);

        if (typeof startDate === 'object')
            this.startDate = moment(startDate);

        if (this.startDate.isValid()) {
            this.container.find('.drp-selected-startDate .text').html(this.startDate.format(this.locale.format));
            this.container.find('.drp-selected-endDate .text').html(AppData.Translations["calendar_arrival_date"]);
            this.container.find('.drp-selected-startDate .caption').removeClass("d-none");
            this.container.find('.drp-selected-endDate .caption').addClass("d-none");
        } else {
            this.container.find('.drp-selected-startDate .text').html(AppData.Translations["calendar_departure_date"]);
            this.container.find('.drp-selected-endDate .text').html(AppData.Translations["calendar_arrival_date"]);
            this.container.find('.drp-selected-startDate .caption').addClass("d-none");
            this.container.find('.drp-selected-endDate .caption').addClass("d-none");
        }
        if (!this.timePicker)
            this.startDate = this.startDate.startOf('day');

        if (this.timePicker && this.timePickerIncrement)
            this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

        if (this.minDate && this.startDate.isBefore(this.minDate)) {
            this.startDate = this.minDate.clone();
            if (this.timePicker && this.timePickerIncrement)
                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        }

        if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
            this.startDate = this.maxDate.clone();
            if (this.timePicker && this.timePickerIncrement)
                this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        }

        if (!this.isShowing)
            this.updateElement();

        this.updateMonthsInView();

    };

    DateRangePicker.prototype.setEndDate_original = DateRangePicker.prototype.setEndDate;
    DateRangePicker.prototype.setEndDate = function (endDate) {
        if (typeof endDate === 'string')
            this.endDate = moment(endDate, this.locale.format);

        if (typeof endDate === 'object')
            this.endDate = moment(endDate);

        if (this.endDate.isValid()) {
            this.container.find('.drp-selected-endDate .text').html(this.endDate.format(this.locale.format));
            this.container.find('.drp-selected-startDate .caption').removeClass("d-none");
            this.container.find('.drp-selected-endDate .caption').removeClass("d-none");
        } else {
            this.container.find('.drp-selected-endDate .text').html(AppData.Translations["calendar_arrival_date"]);
            this.container.find('.drp-selected-startDate .caption').addClass("d-none");
            this.container.find('.drp-selected-endDate .caption').addClass("d-none");
        }

        if (!this.timePicker)
            this.endDate = this.endDate.endOf('day');

        if (this.timePicker && this.timePickerIncrement)
            this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

        if (this.endDate.isBefore(this.startDate))
            this.endDate = this.startDate.clone();

        if (this.maxDate && this.endDate.isAfter(this.maxDate))
            this.endDate = this.maxDate.clone();

        if (this.maxSpan && this.startDate.clone().add(this.maxSpan).isBefore(this.endDate))
            this.endDate = this.startDate.clone().add(this.maxSpan);

        this.previousRightTime = this.endDate.clone();

        this.container.find('.drp-selected').html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));

        if (!this.isShowing)
            this.updateElement();

        this.updateMonthsInView();
    };

    DateRangePicker.prototype.showCalendars_original = DateRangePicker.prototype.showCalendars;
    DateRangePicker.prototype.showCalendars = function () {
        this.container.addClass('show-calendar');
        this.element.trigger('showCalendar.daterangepicker', this);
    };

    DateRangePicker.prototype.updateMonthsInView_original = DateRangePicker.prototype.updateMonthsInView;
    DateRangePicker.prototype.updateMonthsInView = function () {
        if (this.useCalendarList()) {
            var startDate = (!this.inline && useModalDropDown()) ? moment().startOf('day') : this.getInitDate().clone().date(2);

            if (this.endDate) {

                //if both dates are visible already, do nothing
                if (!this.singleDatePicker
                    && this.dateContainedInCalendarList(this.startDate)
                    && this.dateContainedInCalendarList(this.endDate)
                ) {
                    return;
                }

                if (this.singleDatePicker && this.inline) {
                    // hotfix: avoid calenar's moving

                    /*
                    this.calendarList[0].month = startDate.clone().date(2);
                    for (var i = 1; i < this.numberOfMonths; i++) {
                        this.calendarList[i].month = startDate.clone().date(2).add(i, 'month');
                    }
                    */
                    var hasMonths = true;
                    for (var i = 0; i < this.numberOfMonths; i++) {
                        hasMonths = hasMonths && this.calendarList[i].month != null;
                    }

                    //if (hasMonths)
                    //    return;

                    //if both dates are visible already, do nothing
                    if (this.dateContainedInCalendarList(this.startDate) && this.dateContainedInCalendarList(this.endDate)) {
                        return;
                    }
                }

                this.calendarList[0].month = startDate.clone().date(2);
                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) {
                    this.calendarList[1].month = this.endDate.clone().date(2);
                } else {
                    for (var i = 1; i < this.numberOfMonths; i++) {
                        this.calendarList[i].month = startDate.clone().date(2).add(i, 'month');
                    }
                }

            } else {
                if (this.singleDatePicker && this.inline) {
                    // hotfix: avoid calenar's moving
                    return;
                }

                if (!this.dateContainedInCalendarList(this.startDate)) {
                    this.calendarList[0].month = startDate.clone().date(2);
                    for (var i = 1; i < this.numberOfMonths; i++) {
                        this.calendarList[i].month = startDate.clone().date(2).add(i, 'month');
                    }
                }
            }
        } else {
            this.updateMonthsInView_original();
        }
    };

    DateRangePicker.prototype.updateCalendars_original = DateRangePicker.prototype.updateCalendars;
    DateRangePicker.prototype.updateCalendars = function () {
        if (this.useCalendarList()) {
            this.renderCalendarList();
            //highlight any predefined range matching the current start and end dates
            this.container.find('.ranges li').removeClass('active');
            if (this.endDate == null) return;
            this.calculateChosenLabel();
        } else {
            if (this.useCalendarList() === undefined) return;
            this.updateCalendars_original();
        }
    };

    DateRangePicker.prototype.renderCalendarList = function () {
        if (this.useCalendarList()) {
            let is_showNavigation = this.is_showNavigation();
            let is_showMonthNavigation = this.is_showMonthNavigation();
            for (var index = 0; index < this.numberOfMonths; index++) {
                var month = this.calendarList[index].month.month();
                var year = this.calendarList[index].month.year();
                var hour = this.calendarList[index].month.hour();
                var minute = this.calendarList[index].month.minute();
                var second = this.calendarList[index].month.second();
                var daysInMonth = moment([year, month]).daysInMonth();
                var firstDay = moment([year, month, 1]);
                var lastDay = moment([year, month, daysInMonth]);
                var lastMonth = moment(firstDay).subtract(1, 'month').month();
                var lastYear = moment(firstDay).subtract(1, 'month').year();
                var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
                var dayOfWeek = firstDay.day();

                //initialize a 6 rows x 7 columns array for the calendar
                var calendar = [];
                calendar.firstDay = firstDay;
                calendar.lastDay = lastDay;

                for (var i = 0; i < 6; i++) {
                    calendar[i] = [];
                }

                //populate the calendar with date objects
                var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
                if (startDay > daysInLastMonth)
                    startDay -= 7;

                if (dayOfWeek == this.locale.firstDay)
                    startDay = daysInLastMonth - 6;

                var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);

                var col, row;
                for (var i = 0, col = 0, row = 0; i < 42; i++ , col++ , curDate = moment(curDate).add(24, 'hour')) {
                    if (i > 0 && col % 7 === 0) {
                        col = 0;
                        row++;
                    }
                    calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
                    curDate.hour(12);

                    if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && index == 0) {
                        calendar[row][col] = this.minDate.clone();
                    }

                    if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && index == this.numberOfMonths - 1) {
                        calendar[row][col] = this.maxDate.clone();
                    }

                }
                this.calendarList[index].calendar = calendar;

                //
                // Display the calendar
                //


                var minDate = index == 0 ? this.minDate : this.startDate;
                var maxDate = this.maxDate;
                var selected = index == 0 ? this.startDate : this.endDate;
                var arrow = this.locale.direction == 'ltr' ? { left: 'chevron-left', right: 'chevron-right' } : { left: 'chevron-right', right: 'chevron-left' };

                var html = '<table class="table-condensed">';
                html += '<thead>';
                var attrYear = calendar[1][1].year();
                var attrMonth = calendar[1][1].month();
                var attrMonthTitle = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");
                html += '<thead data-year="' + attrYear + '" data-month="' + attrMonth + '" data-month-title="' + attrMonthTitle + '">';
                if (is_showMonthNavigation) {
                    html += '<tr>';

                    // add empty cell for week number
                    if (this.showWeekNumbers || this.showISOWeekNumbers)
                        html += '<th></th>';

                    if (is_showNavigation && (!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || index == 0)) {
                        html += '<th class="prev available"><span></span></th>';
                    } else {
                        html += '<th></th>';
                    }

                    var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");

                    if (this.showDropdowns) {
                        var currentMonth = calendar[1][1].month();
                        var currentYear = calendar[1][1].year();
                        var maxYear = (maxDate && maxDate.year()) || (this.maxYear);
                        var minYear = (minDate && minDate.year()) || (this.minYear);
                        var inMinYear = currentYear == minYear;
                        var inMaxYear = currentYear == maxYear;

                        var monthHtml = '<select class="monthselect">';
                        for (var m = 0; m < 12; m++) {
                            if ((!inMinYear || (minDate && m >= minDate.month())) && (!inMaxYear || (maxDate && m <= maxDate.month()))) {
                                monthHtml += "<option value='" + m + "'" +
                                    (m === currentMonth ? " selected='selected'" : "") +
                                    ">" + this.locale.monthNames[m] + "</option>";
                            } else {
                                monthHtml += "<option value='" + m + "'" +
                                    (m === currentMonth ? " selected='selected'" : "") +
                                    " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
                            }
                        }
                        monthHtml += "</select>";

                        var yearHtml = '<select class="yearselect">';
                        for (var y = minYear; y <= maxYear; y++) {
                            yearHtml += '<option value="' + y + '"' +
                                (y === currentYear ? ' selected="selected"' : '') +
                                '>' + y + '</option>';
                        }
                        yearHtml += '</select>';

                        dateHtml = monthHtml + yearHtml;
                    }

                    html += '<th colspan="5" class="month">' + dateHtml + '</th>';
                    if (is_showNavigation && (!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || index == this.numberOfMonths - 1 || this.singleDatePicker)) {
                        html += '<th class="next available"><span></span></th>';
                    } else {
                        html += '<th></th>';
                    }

                    html += '</tr>';
                }
                html += '<tr>';

                // add week number label
                if (this.showWeekNumbers || this.showISOWeekNumbers)
                    html += '<th class="week">' + this.locale.weekLabel + '</th>';

                $.each(this.locale.daysOfWeek, function (index, dayOfWeek) {
                    html += '<th>' + dayOfWeek + '</th>';
                });

                html += '</tr>';
                html += '</thead>';
                html += '<tbody>';

                //adjust maxDate to reflect the maxSpan setting in order to
                //grey out end dates beyond the maxSpan
                if (this.endDate == null && this.maxSpan) {
                    var maxLimit = this.startDate.clone().add(this.maxSpan).endOf('day');
                    if (!maxDate || maxLimit.isBefore(maxDate)) {
                        maxDate = maxLimit;
                    }
                }

                for (var row = 0; row < 6; row++) {
                    var weekHtml = '';
                    var weekClass = '';
                    var hasCurrentMonthDays = false;
                    // add week number
                    if (this.showWeekNumbers)
                        weekHtml += '<td class="week">' + calendar[row][0].week() + '</td>';
                    else if (this.showISOWeekNumbers)
                        weekHtml += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';

                    for (var col = 0; col < 7; col++) {

                        var classes = [];

                        //highlight today's date
                        if (calendar[row][col].isSame(new Date(), "day"))
                            classes.push('today');

                        //highlight weekends
                        if (calendar[row][col].isoWeekday() > 5)
                            classes.push('weekend');

                        //grey out the dates in other months displayed at beginning and end of this calendar
                        if (calendar[row][col].month() != calendar[1][1].month()) {
                            if (this.hideOtherMonthDays) {
                                classes.push('off', 'ends', 'invisible');
                            } else {
                                classes.push('off', 'ends');
                            }
                        } else {
                            hasCurrentMonthDays = true;
                        }

                        //don't allow selection of dates before the minimum date
                        if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day'))
                            classes.push('off', 'disabled');

                        //don't allow selection of dates after the maximum date
                        if (maxDate && calendar[row][col].isAfter(maxDate, 'day'))
                            classes.push('off', 'disabled');

                        //don't allow selection of date if a custom function decides it's invalid
                        if (this.isInvalidDate(calendar[row][col]))
                            classes.push('off', 'disabled');

                        //highlight the currently selected start date
                        if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD'))
                            classes.push('active', 'start-date');

                        //highlight the currently selected end date
                        if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD'))
                            classes.push('active', 'end-date');

                        //highlight dates in-between the selected dates
                        if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate)
                            classes.push('in-range');

                        //apply custom classes for this date
                        var isCustom = this.isCustomDate(calendar[row][col]);
                        if (isCustom !== false) {
                            if (typeof isCustom === 'string')
                                classes.push(isCustom);
                            else
                                Array.prototype.push.apply(classes, isCustom);
                        }

                        // renderDateValue
                        var htmlDate = '';
                        if (typeof this.renderDateValue == "function") {
                            htmlDate = this.renderDateValue(calendar[row][col], classes, index);
                        } else {
                            htmlDate = calendar[row][col].date();
                        }

                        var attrDate = '';
                        if (typeof this.renderDateAttributes == "function") {
                            attrDate = this.renderDateAttributes(calendar[row][col], classes, index);
                        }
                        if (attrDate == null || typeof attrDate == "undefined") {
                            attrDate = '';
                        }


                        var cname = '', disabled = false;
                        for (var i = 0; i < classes.length; i++) {
                            cname += classes[i] + ' ';
                            if (classes[i] == 'disabled')
                                disabled = true;
                        }
                        if (!disabled)
                            cname += 'available';

                        // using renderDateValue
                        weekHtml += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '" ' +attrDate + '>' + htmlDate + '</td>';

                    }
                    weekClass = (!hasCurrentMonthDays && this.hideOtherMonthDays) ? "d-none" : "";
                    html += '<tr class="' + weekClass + '">' + weekHtml + '</tr>';
                }

                html += '</tbody>';
                html += '</table>';

                this.container.find('[data-calendar-index="' + index + '"] .calendar-table').html(html);

            }
        }
    };

    DateRangePicker.base.move_original = DateRangePicker.base.move;
    DateRangePicker.base.move = function () {
        if (this.inline) {
            this.container.removeClass('opens' + this.opens)
            /*
            this.container.css('top','');
            this.container.css('left','');
            this.container.css('right','');
            this.container.css('position','relative');
            this.container.css('top',0);
            this.container.css('left',0);
            this.container.css('right','auto');
            */
        } else {
            this.container.addClass('opens' + this.opens)
            this.container.css('position','');
            this.move_original();
        }
    };

    DateRangePicker.prototype.show_original = DateRangePicker.prototype.show;
    DateRangePicker.prototype.show = function () {
        if (this.useCalendarList()) {
            this.initCalendarList();
            this.show_original();
        } else {
            this.show_original();
        }
    };

    DateRangePicker.base.outsideClick_original = DateRangePicker.base.outsideClick;
    DateRangePicker.base.outsideClick = function (e) {
        if (this.inline) {
            // ...
        } else {
            this.outsideClick_original(e);
        }
    };
    

    DateRangePicker.prototype.hoverDate_original = DateRangePicker.prototype.hoverDate;
    DateRangePicker.prototype.hoverDate = function (e) {
        if (this.useCalendarList()) {
            //ignore dates that can't be selected
            if (!$(e.target).hasClass('available')) return;

            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.drp-calendar');
            var index = cal.data("calendar-index");
            if (index == undefined) return;
            var date = this.calendarList[index].calendar[row][col];
            var calendarList = this.calendarList;
            var startDate = this.startDate;

            if (!this.endDate) {
                this.container.find('.drp-calendar tbody td').each(function (i, el) {

                    //skip week numbers, only look at dates
                    if ($(el).hasClass('week')) return;

                    var title = $(el).attr('data-title');
                    var row = title.substr(1, 1);
                    var col = title.substr(3, 1);
                    var cal = $(el).parents('.drp-calendar');
                    var index = cal.data("calendar-index");
                    var dt = calendarList[index].calendar[row][col];
                    if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
                        $(el).addClass('in-range');
                    } else {
                        $(el).removeClass('in-range');
                    }
                });
            }
        } else {
            this.hoverDate_original(e);
        }
    };

    DateRangePicker.prototype.clickDate_original = DateRangePicker.prototype.clickDate;
    DateRangePicker.prototype.clickDate = function (e) {
        /*
            1 = Left   mouse button
            2 = Centre mouse button
            3 = Right  mouse button
        */
        if (e.which !== 1) {
            // avoid none Left-Mouse-Button click
            return;
        }

        if (this.useCalendarList()) {
            if (!$(e.target).hasClass('available')) return;

            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.drp-calendar');
            var index = cal.data("calendar-index");
            if (index == undefined) return;
            var date = this.calendarList[index].calendar[row][col];

            //
            // this function needs to do a few things:
            // * alternate between selecting a start and end date for the range,
            // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
            // * if autoapply is enabled, and an end date was chosen, apply the selection
            // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
            // * if one of the inputs above the calendars was focused, cancel that manual input
            //

            if (this.endDate || date.isBefore(this.startDate, 'day')) { //picking start
                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                    var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    if (isNaN(minute)) {
                        minute = parseInt(this.container.find('.left .minuteselect option:last').val(), 10);
                    }
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.endDate = null;
                this.setStartDate(date.clone());
            } else if (!this.endDate && date.isBefore(this.startDate)) {
                //special case: clicking the same date for start/end,
                //but the time of the end date is before the start date
                this.setEndDate(this.startDate.clone());
            } else { // picking end
                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                    var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    if (isNaN(minute)) {
                        minute = parseInt(this.container.find('.right .minuteselect option:last').val(), 10);
                    }
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.setEndDate(date.clone());
                if (this.autoApply) {
                    this.calculateChosenLabel();
                    this.clickApply();
                }
            }

            if (this.singleDatePicker) {
                this.setEndDate(this.startDate);
                if (!this.timePicker)
                    this.clickApply();
            }

            this.updateView();

            //This is to cancel the blur event handler if the mouse was in one of the inputs
            e.stopPropagation();
      
        } else {
            this.clickDate_original(e);
        }
    };
          
    DateRangePicker.prototype.clickPrev_original = DateRangePicker.prototype.clickPrev;
    DateRangePicker.prototype.clickPrev = function (e) {
        if (this.useCalendarList()) {
            for (var i = 0; i < this.numberOfMonths; i++) {
                this.calendarList[i].month.subtract(1, 'month');
            }
            this.updateCalendars();
        } else {
            this.clickPrev_original(e);
        }
        this.element.trigger('prevMonth.daterangepicker', this);
    };

    DateRangePicker.prototype.clickNext_original = DateRangePicker.prototype.clickNext;
    DateRangePicker.prototype.clickNext = function (e) {
        if (this.useCalendarList()) {
            for (var i = 0; i < this.numberOfMonths; i++) {
                this.calendarList[i].month.add(1, 'month');
            }
            this.updateCalendars();
        } else {
            this.clickNext_original(e);
        }
        this.element.trigger('nextMonth.daterangepicker', this);
    };

    DateRangePicker.base.clickApply_original = DateRangePicker.base.clickApply;
    DateRangePicker.base.clickApply = function (e) {
        if (!this.inline) {
            this.hide();
        }
        this.element.trigger('apply.daterangepicker', this);
    },

    DateRangePicker.base.clickCancel_original = DateRangePicker.base.clickCancel;
    DateRangePicker.base.clickCancel = function (e) {
        this.startDate = this.oldStartDate;
        this.endDate = this.oldEndDate;
        if (!this.inline) {
            this.hide();
        }
        this.element.trigger('cancel.daterangepicker', this);
    },

    $.fn.daterangepicker = function(options, callback) {
        var implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);
        this.each(function() {
            var el = $(this);
            if (el.data('daterangepicker'))
                el.data('daterangepicker').remove();
            el.data('daterangepicker', new DateRangePicker(el, implementOptions, callback));
        });
        return this;
    };

    return DateRangePicker;
}));